module.exports = __webpack_public_path__ + "img/cramo-logo.4b27c03a.svg";